// Copyright (c) 2016 Deere & Company

const dropdownPlaceholders = [
    'SELECT_STATUS',
    'SELECT_COUNTRY',
    'SELECT_STATE'
];

export default dropdownPlaceholders;



// WEBPACK FOOTER //
// ./src/product/status-change-request/utils/dropdown-placeholders.js